<template>
  <div class="mx-auto w-full">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center pb-4">
        <b-select rounded v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="500">500 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>

        <vs-dropdown>
          <vs-button
            class="btn-drop"
            color="#5b3cc4"
            type="filled"
            icon="touch_app"
            >Column</vs-button
          >

          <vs-dropdown-menu>
            <vs-dropdown-group vs-label="Column">
              <vs-dropdown-item @click="showCol">Show/Hide</vs-dropdown-item>
            </vs-dropdown-group>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          placeholder="Search"
          v-model="searchval"
          @keydown.enter="goSearch"
        />

        <div v-if="colshow" class="mt-4">
          <div
            v-for="(column, index) in columnsTemplate"
            :key="index"
            class="control"
          >
            <b-checkbox v-model="column.visible">{{ column.title }}</b-checkbox>
          </div>
        </div>

        <b-table
          class="w-full mt-4"
          :data="data"
          :loading="loading"
          :striped="isStriped"
          :narrowed="isNarrowed"
          :hoverable="isHoverable"
          :selected.sync="selected"
          paginated
          backend-pagination
          :total="total"
          :per-page="perPage"
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          backend-sorting
          :default-sort-direction="defaultSortOrder"
          :default-sort="[sortField, sortOrder]"
          @sort="onSort"
          :sticky-header="stickyHeaders"
          height="800px"
        >
                  <template slot="bottom-left">
            <h3>Total : {{ total }}</h3>
          </template>

          <b-input
            class="w-full"
            slot="searchable"
            slot-scope="props"
            v-model="props.filters[props.column.field]"
            placeholder="Search..."
            size="is-small"
          />

          <template slot-scope="props">
            <b-table-column
              :field="columnsTemplate[0].field"
              :label="columnsTemplate[0].title"
              :visible="columnsTemplate[0].visible"
              sortable
              searchable
              >{{ props.row.number }}</b-table-column
            >

            
            <b-table-column
              :field="columnsTemplate[1].field"
              :label="columnsTemplate[1].title"
              :visible="columnsTemplate[1].visible"
              sortable
              searchable
              >{{
                cvDateNoTime(props.row.invdate)}}</b-table-column
            >      

            <b-table-column
              :field="columnsTemplate[2].field"
              :label="columnsTemplate[2].title"
              :visible="columnsTemplate[2].visible"
              sortable
              searchable
              >{{ props.row.businessPartnersCode }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[3].field"
              :label="columnsTemplate[3].title"
              :visible="columnsTemplate[3].visible"
              sortable
              searchable
              >{{ props.row.paymentTerm }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[4].field"
              :label="columnsTemplate[4].title"
              :visible="columnsTemplate[4].visible"
              sortable
              searchable
              >{{ props.row.paymentType }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[5].field"
              :label="columnsTemplate[5].title"
              :visible="columnsTemplate[5].visible"
              sortable
              searchable
              >{{ props.row.remark }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[6].field"
              :label="columnsTemplate[6].title"
              :visible="columnsTemplate[6].visible"
              sortable
              searchable
              >{{ props.row.itemnum }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[7].field"
              :label="columnsTemplate[7].title"
              :visible="columnsTemplate[7].visible"
              sortable
              searchable
              >{{ props.row.hawb }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[8].field"
              :label="columnsTemplate[8].title"
              :visible="columnsTemplate[8].visible"
              sortable
              searchable
              >{{ props.row.handlingChargesCode }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[9].field"
              :label="columnsTemplate[9].title"
              :visible="columnsTemplate[9].visible"
              sortable
              searchable
              >{{ props.row.description }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[10].field"
              :label="columnsTemplate[10].title"
              :visible="columnsTemplate[10].visible"
              sortable
              searchable
              >{{ formatnumber(props.row.unitPrice) }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[11].field"
              :label="columnsTemplate[11].title"
              :visible="columnsTemplate[11].visible"
              sortable
              searchable
              >{{ formatnumber(props.row.totalAmount) }}</b-table-column
            > 

            <b-table-column
              :field="columnsTemplate[12].field"
              :label="columnsTemplate[12].title"
              :visible="columnsTemplate[12].visible"
              sortable
              searchable
              >{{ props.row.shipmentNumber }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[13].field"
              :label="columnsTemplate[13].title"
              :visible="columnsTemplate[13].visible"
              sortable
              searchable
              >{{ props.row.exbordersNumber }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[14].field"
              :label="columnsTemplate[14].title"
              :visible="columnsTemplate[14].visible"
              sortable
              searchable
              >{{ props.row.movesNumber }}</b-table-column
            >

            <b-table-column
              :field="columnsTemplate[15].field"
              :label="columnsTemplate[15].title"
              :visible="columnsTemplate[15].visible"
              sortable
              searchable
              >{{ props.row.status }}</b-table-column
            >

          </template>
        </b-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      data: [],
      colshow: false,
      selected: null,
      total: 0,
      loading: false,
      isStriped: false,
      isHoverable: true,
      isNarrowed: false,
      stickyHeaders: true,
      sortField: "invdate",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      page: 1,
      perPage: 20,
      searchval: "",
      columnsTemplate: [
        { title: "Number", field: "number", visible: true },
        { title: "Invoice Date", field: "invdate", visible: true },
        { title: "Business Partner", field: "businessPartnersCode", visible: true },
        { title: "Payment Term", field: "paymentTerm", visible: true },
        { title: "Payment Type", field: "paymentType", visible: true },
        { title: "Remark", field: "remark", visible: true },
        { title: "Item Number", field: "itemnum", visible: true },
        { title: "HAWB", field: "hawb", visible: true },
        { title: "handlingChargesCode", field: "handlingChargesCode", visible: true },
        { title: "Description", field: "description", visible: true },
        { title: "unitPrice", field: "unitPrice", visible: true },
        { title: "totalAmount", field: "totalAmount", visible: true },
        { title: "Inbound Number", field: "shipmentNumber", visible: true },
        { title: "Outbound Number", field: "exbordersNumber", visible: true },
        { title: "Move Number", field: "movesNumber", visible: true },
        { title: "Status", field: "status", visible: true },
      ],
      background: "#23d160 !important",
      color: "white !important",
    };
  },
  props: ["fromDate", "toDate"],
  methods: {
        cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvDateNoTime(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    showCol() {
      if (this.colshow == true) {
        this.colshow = false;
      } else {
        this.colshow = true;
      }
    },
    async getData() {
      // alert("Hi");
      // console.log(this.fromDate);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            sortField: this.sortField,
            sortOrder: this.sortOrder,
            page: this.page,
            perpage: this.perPage,
            companyGroupsCode: this.companyGroupsCode,
            searchval: this.searchval,
            fromDate: this.fromDate,
            toDate: this.toDate,
            // from: '2022-01-11'
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/invoices/invoicesReport`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data,
            });
          } else {
            this.loading = false;

            this.data = [];
            let currentTotal = response.data.total_results;
            if (response.data.total_results / this.perPage > 1000) {
              currentTotal = this.perPage * 1000;
            }
            this.total = currentTotal;

            response.data.data.forEach((item) => {
              this.data.push(item);
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    /*
     * Handle page-change event
     */
    onPageChange(page) {
      this.page = page;
      this.getData();
    },
    /*
     * Handle sort event
     */
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.getData();
    },
    /*
     * Type style in relation to the value
     */
    type(value) {
      const number = parseFloat(value);
      if (number < 6) {
        return "is-danger";
      } else if (number >= 6 && number < 8) {
        return "is-warning";
      } else if (number >= 8) {
        return "is-success";
      }
    },
    // Format Number
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    // Search
    goSearch() {
      // console.log(this.searchval);
      this.getData();
    },
  },
  mounted() {
    // console.log(this.fromDate);
    this.getData();
    // setTimeout(() => {
    //     this.selected = this.data[1];
    // }, 500);
  },
  computed: {
    rowSelected() {
      return this.selected;
    },
    perPageChanged() {
      return this.perPage;
    },
    dbchanged() {
      return this.$store.state.reportgrid;
    },
  },
  watch: {
    rowSelected: function () {
      // console.log(this.selected);
      // this.$emit("recsel", this.selected.number);
    },
    perPageChanged: function () {
      this.getData();
    },
    dbchanged: function () {
      // console.log("dbchanged");
      this.getData();
    },
  },
};
</script>

<style>
.is-sticky-column-one {
  background: #23d160 !important;
  color: white !important;
}
.is-sticky-column-two {
  background: #167df0 !important;
  color: white !important;
}
</style>